<template>
  <div class="home">
    <main role="main" class="ml-sm-auto col-xl-10 px-4">
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Synchronisation Hiboutik(test)</h1>
      </div>
      <div>
        <button class="btn btn-primary" @click="modele_sync">Lancer la synchro des modeles</button>
        <br><br><br>
        <button class="btn btn-primary" @click="client_sync">Lancer la synchro des clients</button>
        <br><br><br>
        <button class="btn btn-primary" @click="client_by_email">Get Client by email</button>
        <br><br><br>
        <button class="btn btn-primary" @click="add_client">Ajouter un Client</button>
        <br><br><br>
        <button class="btn btn-primary" @click="add_sale">Ajouter une vente</button>
        <div ref="sales_redirect"></div>
      </div>
    </main>
  </div>
</template>

<script>
import { syncModeles, syncClients,getHiboutikClientByEmail, addHiboutikSale, addHiboutikClient } from '@/api/crm-api.js'
/* global $ */
export default {
  methods: {
    modele_sync() {
      syncModeles().then((response) => {
        this.$store.commit('addMessage',{ text:response.data, status:'success' })
      })
      .catch((error) => {
        this.$store.commit('addMessage',{ text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger' })
      })
    },
    client_sync() {
      syncClients().then((response) => {
        this.$store.commit('addMessage',{ text:response.data, status:'success' })
      })
      .catch((error) => {
        this.$store.commit('addMessage',{ text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger' })
      })
    },
    client_by_email() {
      getHiboutikClientByEmail('yaniv@toto.fr').then((response) => {
        this.$store.commit('addMessage',{ text:response.data, status:'success' })
      })
      .catch((error) => {
        this.$store.commit('addMessage',{ text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger' })
      })
    },
    add_client() {
      addHiboutikClient("First","Last","bbb@toto.Fr","addresse","zipcode","city","0123456789").then((response) => {
        this.$store.commit('addMessage',{ text:response.data, status:'success' })
      })
      .catch((error) => {
        this.$store.commit('addMessage',{ text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger' })
      })
    },
    add_sale() {
      let clientEmail = 'yaniv@toto.fr';
      addHiboutikSale(clientEmail).then((response) => {

        //Then redirect to sales
        let sales_id = response.data
        $(this.$refs.sales_redirect).html('<form name="sales-'+sales_id+'-redirect" action="https://dromax.hiboutik.com/" target="vente-'+sales_id+'" method="post" style="display:none;"><input type="hidden" name="action" value="ma_commande_affiche" /><input type="hidden" name="ma_commande_affiche" value="'+sales_id+'"></form>');
        document.forms['sales-'+sales_id+'-redirect'].submit()

        this.$store.commit('addMessage',{ text:'La vente numéro '+response.data+' à  été créee', status:'success' })
      })
      .catch((error) => {
        this.$store.commit('addMessage',{ text:'Une erreur s\'est produite: <br>'+error, status:'danger' })
      })
    }
  }
}
</script>

<style>

</style>
